import { graphql } from 'gql'

export const UPDATE_AD_UNIT_PRODUCT_ENABLED = graphql(`
  mutation updateAdUnitsForProductSwitch($input: UpdateAdUnitsInput!) {
    updateAdUnits(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
